import TextEditor from '@intercom/embercom-composer/components/text-editor';
export default TextEditor;
